<app-page-container class="event-registration-container" [layoutType]="LayoutType.IntegratedTab" [tabConfig]="tabConfig"
    [title]="title" [props]="tabProps" [showBreadcrumb]="true" [breadcrumbProps]="breadcrumbProps">
</app-page-container>